module.exports = __webpack_public_path__ + "bi.ddbe8e3fcc658d45f80a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bi.svg
// module chunks = styles